/* @flow */
import ms from 'ms';
import {List} from 'immutable';

export const KEEPALIVE_ENDPOINT = '/tools/session';

export const LOGIN_ENDPOINT = '/login';
export const LOGIN_ENDPOINT_AUTHPATH = '/auth/login';

export const LOGOUT_ENDPOINT = '/logout'; // Vestigial
export const LOGOUT_ENDPOINT_AUTHPATH = '/auth/logout';

export const SIGN_EULA_ENDPOINT = '/services/users/eula';
export const MFA_VERIFY_RESPONSE_ENDPOINT = '/services/auth/mfa';
export const CHANGE_PASSWORD_ENDPOINT = '/services/password/update';
export const FORGOT_PASSWORD_ENDPOINT = '/services/password/forgot';

export const WARNING = 'warning';
export const LOGOUT = 'logOut';

export const SERVER_SESSION_TIME = ms('30m');
export const LOGIN_TIMEOUT_MS = ms('15s');
export const ACTIVITY_LOCAL_STORAGE_POLL_FREQUENCY_MS = ms('15s');

export const STORED_USERNAME_LOCALSTORAGE_KEY = 'TS_STORED_USERNAME';
export const COMING_FROM_APP = 'TS_CFA';
export const IS_LOGGED_IN_LOCALSTORAGE_KEY = 'TS_IS_LOGGED_IN';
export const LAST_USER_ACTION_LOCALSTORAGE_KEY = 'LUA_TS';

export const LAST_VIEWED_SEARCH = 'search';
export const LAST_VIEWED_REPORTS = 'reports';
export const LAST_VIEWED_INDICATORS = 'indicators';


export const TRUSTAR_SUPPORT_PAGE = 'https://trustar.atlassian.net/servicedesk/customer/portal/1/group/1/create/1';

export const ROUTES_THAT_SHOULD_NOT_HAVE_SUBMIT_BUTTON = List(['create', 'review', 'update']);


// WEBPACK FOOTER //
// ./src/app/modules/app/constants.js